var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "发起拼团",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.qrCode
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "flex-direction": "column",
                  },
                },
                [
                  _c("el-alert", {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: {
                      title:
                        "拼团信息已生成，可下载分享码，详细信息请在拼团列表中查看",
                      type: "success",
                      "show-icon": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-image", {
                    staticStyle: { width: "200px", height: "200px" },
                    attrs: {
                      src: _vm.qrCode,
                      "preview-src-list": [_vm.qrCode],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "30px",
                        color: "#1791ff",
                        "text-decoration": "underline",
                        cursor: "pointer",
                      },
                      on: { click: _vm.downloadQrcode },
                    },
                    [_vm._v("点击下载分享码")]
                  ),
                ],
                1
              )
            : _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.initloading,
                      expression: "initloading",
                    },
                  ],
                  ref: "pram",
                  attrs: { model: _vm.pram, "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "发起小程序：",
                        prop: "customerId",
                        rules: [
                          {
                            required: true,
                            message: "请选择",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: { change: _vm.changeSelect },
                          model: {
                            value: _vm.pram.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "customerId", $$v)
                            },
                            expression: "pram.customerId",
                          },
                        },
                        _vm._l(_vm.cosotmerOption, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.name + "【" + item.id + "】",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#999" } }, [
                        _vm._v("需要提前在小程序客户中绑定需要拼团的商品！"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "发起团长：",
                        prop: "uid",
                        rules: [
                          {
                            required: true,
                            message: "请选择",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择",
                            filterable: "",
                            "filter-method": _vm.searchUsers,
                          },
                          model: {
                            value: _vm.pram.uid,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "uid", $$v)
                            },
                            expression: "pram.uid",
                          },
                        },
                        _vm._l(_vm.userLists, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: item.value, value: item.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.pram.isSelfPickup == 1
                    ? [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#000",
                              "font-weight": "500",
                              "margin-top": "30px",
                            },
                          },
                          [_vm._v("自提信息：")]
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "联系人：", prop: "realName" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.pram.realName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "realName", $$v)
                                },
                                expression: "pram.realName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "联系电话：", prop: "phone" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.pram.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "phone", $$v)
                                },
                                expression: "pram.phone",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "选择地区：", prop: "areaList" } },
                          [
                            _c("el-cascader", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                options: _vm.addresData,
                                props: {
                                  value: "name",
                                  label: "name",
                                  children: "child",
                                  checkStrictly: true,
                                },
                              },
                              model: {
                                value: _vm.pram.areaList,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "areaList", $$v)
                                },
                                expression: "pram.areaList",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "详细地址：", prop: "detail" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.pram.detail,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "detail", $$v)
                                },
                                expression: "pram.detail",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              [
                _vm.qrCode
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: { click: _vm.closeRefresh },
                      },
                      [_vm._v("知道了")]
                    )
                  : _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: { click: _vm.handerSubmit },
                      },
                      [_vm._v("生成分享码")]
                    ),
              ],
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }